/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function Streamers() {
  return (
    <>
      <div className="section section-dark text-center gradient-background-claro">
        <Container>
          <h2 className="title gradient-title"> Streamers </h2>
          <hr style={{ clear: 'both' }} />
          <Row>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.facebook.com/KardeckGamer/" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/KG.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.facebook.com/KardeckGamer/" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> KardeckGamer </CardTitle>
                      <h6 className="card-category"> Gamer </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making the first direct of the game!!
                  </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/user/Thekakaserth"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/KardeckGamer/"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.instagram.com/kardeckgamer/?hl=pt-br"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-instagram" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/user/aniclog2" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/CanalBySpeed.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/user/aniclog2" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Canal BySpeed </CardTitle>
                      <h6 className="card-category"> MK Pro Player </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    All the support and motivation throughout the development of the new version!
                    A hug to the Legion!!
                  </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/user/aniclog2"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/groups/1477853065627502"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.instagram.com/alan_speedmk/"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-instagram" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.twitch.tv/canalbyspeed"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-twitch" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/c/NoContinues" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/No_Continues.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/c/NoContinues" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> No Continues </CardTitle>
                      <h6 className="card-category"> Gamer </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making one of the first online live streams of the game !!
                  </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/c/NoContinues"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.twitch.tv/no_continues_"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <i className="fa fa-twitch" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default Streamers;
